import React from "react";

import { Button } from "@xometry/xometry_loft";
import { useConfig } from "../../proposals/contexts/configContext";

const ViewSupplierDirectoryButton = () => {
  const { origins } = useConfig();
  const suppliersDirectoryUrl = `${origins.www}/suppliers/search`;

  return (
    <a href={suppliersDirectoryUrl}>
      <Button kind="primary" size="large">
        View Supplier Directory
      </Button>
    </a>
  );
};

export default ViewSupplierDirectoryButton;
